import { AxiosProgressEvent, AxiosResponse } from 'axios';

import { FileManagementResponse } from '../../../../types/FileManagementResponse';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const uploadInternalFile = async (
    file: File,
    offerId: string,
    onUploadProgress: (event: AxiosProgressEvent) => void
): Promise<FileManagementResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await authorizedAxiosInstance.post(`/v2/offers/${offerId}/internal-files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });

    return response.data;
};

export const downloadInternalFile = (fileId: string, offerId: string): Promise<AxiosResponse> => {
    return authorizedAxiosInstance.get(`/v2/offers/${offerId}/internal-files/${fileId}/download`, {
        responseType: 'blob',
    });
};

export const deleteInternalFile = async (fileId: string, offerId: string): Promise<void> => {
    await authorizedAxiosInstance.delete(`/v2/offers/${offerId}/internal-files/${fileId}`);
};
